/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Fee_Keep_AllInputs */

const vi_sales_return_fee_keep_all = /** @type {(inputs: Sales_Return_Fee_Keep_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không trả lại tiền`)
};

/**

* @param {Sales_Return_Fee_Keep_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_fee_keep_all = /** @type {((inputs?: Sales_Return_Fee_Keep_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Fee_Keep_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_fee_keep_all(inputs)
});